import SvgIcon from '@/pages/home/components/SvgIcon';
import DEFAULT_COUNTRY_ICON from '@gp/assets/svg/flag-default.svg';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import LinkJump from '@gp/components/LinkJump';
import { queryJumpable } from '@gp/utils/common';
import React from 'react';
import { Bubble } from 'tea-component';
import './index.scss';

export default function ProjectsItems(props: any) {
  const {
    data,
    bubble,
    toDetails,
    allCountryFlag,
    isNeedPromise = false,
    toDetailsTrueFun,
  } = props;
  const { project: content, cover, country_en_name_abbr, country_en_name } = data || {};

  return (
    <div className="dbg-projects-items">
      <LinkJump style={{ height: 42 }} url={toDetails?.(false)}>
        <GeneralImageNew
          className="dbg-projects-items-img"
          domain="game"
          src={cover}
          width={36}
          height={36}
          onClick={(e) => {
            if (!queryJumpable(e)) return;
            isNeedPromise ? toDetailsTrueFun(true) : toDetails(true);
          }}
        />
      </LinkJump>
      <div className="dbg-projects-items-text">
        <div className="dbg-projects-items-text-content">
          <LinkJump className="dbg-projects-items-content-text" url={toDetails?.(false)}>
            <Bubble
              className="globalpedia-modal-font14"
              arrowPointAtCenter={false}
              placement="top-start"
              content={bubble}
              dark={true}
            >
              <span
                onClick={(e) => {
                  if (!queryJumpable(e)) return;
                  isNeedPromise ? toDetailsTrueFun(true) : toDetails(true);
                }}
              >
                {content}
              </span>
            </Bubble>
          </LinkJump>
        </div>
        <div className="dbg-projects-items-message">
          <SvgIcon className="dbg-projects-items-message-icon" type={data?.game_type} />
          <img
            className="dbg-projects-items-message-img"
            src={allCountryFlag[country_en_name_abbr] || DEFAULT_COUNTRY_ICON}
            onError={(e) => {
              e.target.src = DEFAULT_COUNTRY_ICON;
            }}
          />
          {country_en_name || '-'}
        </div>
      </div>
    </div>
  );
}
